/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const refresh = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M.68 5.448a.75.75 0 0 0 1.417.494L.68 5.448Zm13.931.247-.708.247.072.207.173.135.463-.59Zm.709 4.857a.75.75 0 0 0-1.417-.494l1.417.494Zm-13.932-.247.709-.247-.073-.207-.172-.135-.464.59ZM15 6v.75a.75.75 0 0 0 .75-.75H15Zm.75-4.333a.75.75 0 0 0-1.5 0h1.5ZM10.667 5.25a.75.75 0 0 0 0 1.5v-1.5Zm-5.334 5.5a.75.75 0 0 0 0-1.5v1.5ZM1 10v-.75a.75.75 0 0 0-.75.75H1Zm-.75 4.333a.75.75 0 0 0 1.5 0H.25Zm1.847-8.391A6.253 6.253 0 0 1 8 1.75V.25A7.753 7.753 0 0 0 .68 5.448l1.417.494ZM8 1.75c2.73 0 5.052 1.75 5.903 4.192l1.417-.494A7.753 7.753 0 0 0 8 .25v1.5Zm5.903 8.308A6.253 6.253 0 0 1 8 14.25v1.5a7.753 7.753 0 0 0 7.32-5.198l-1.417-.494ZM8 14.25a6.253 6.253 0 0 1-5.903-4.192l-1.417.494A7.753 7.753 0 0 0 8 15.75v-1.5ZM15.75 6V1.667h-1.5V6h1.5ZM15 5.25h-4.333v1.5H15v-1.5Zm-9.667 4H1v1.5h4.333v-1.5ZM.25 10v4.333h1.5V10H.25Zm13.898-3.716.389.306.926-1.18-.388-.305-.927 1.18ZM1.852 9.716l-.389-.306-.926 1.18.388.305.927-1.18Z"
    />
  </svg>
)
export default refresh
